import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, CheckCircle2, ArrowRight, Instagram, ShieldCheck, ShoppingCart } from 'lucide-react';
import { PRODUCTS } from '../data/products';
import { useCartStore } from '../store/useCartStore';
export function ProductPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const product = PRODUCTS.find(p => p.id === Number(id));
  const {
    addItem,
    items,
    openCart
  } = useCartStore();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  if (!product) {
    return <div className="min-h-screen flex items-center justify-center bg-brand-bg" data-id="element-246">
        <div className="text-center" data-id="element-247">
          <h1 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-248">
            Товар не знайдено
          </h1>
          <button onClick={() => navigate('/')} className="text-brand-yellow font-bold hover:underline" data-id="element-249">
            Повернутися на головну
          </button>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-brand-bg text-brand-text selection:bg-brand-yellow selection:text-brand-blueDark font-sans pt-24" data-id="element-250">
      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-8 lg:py-16" data-id="element-251">
        <Link to="/" className="inline-flex items-center gap-2 text-brand-muted hover:text-brand-blue font-bold mb-8 transition-colors" data-id="element-252">
          <ArrowLeft className="w-5 h-5" data-id="element-253" />
          Назад до всіх планерів
        </Link>

        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 p-6 lg:p-10" data-id="element-254">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12" data-id="element-255">
            {/* Мобільний заголовок та бейдж (видно тільки на мобільному) */}
            <div className="lg:hidden flex flex-col items-center text-center gap-3 mb-2" data-id="element-256">
              <div className="inline-flex items-center justify-center gap-1.5 text-gray-500" data-id="element-257">
                <ShieldCheck className="w-4 h-4" data-id="element-258" />
                <span className="font-medium text-xs uppercase tracking-wider" data-id="element-259">
                  В наявності
                </span>
              </div>
              <h1 className="text-3xl font-black text-brand-blue leading-tight" data-id="element-260">
                {product.title}
              </h1>
            </div>

            {/* Ліва частина: Фото */}
            <div className="w-full lg:w-1/2 flex-shrink-0" data-id="element-261">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5
            }} className="relative w-full rounded-2xl overflow-hidden border border-gray-100 bg-gray-50" data-id="element-262">
                <img src={product.img} alt={product.title} className="w-full h-auto object-contain" data-id="element-263" />
              </motion.div>
            </div>

            {/* Права частина: Інформація */}
            <div className="w-full lg:w-1/2 flex flex-col text-center lg:text-left" data-id="element-264">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="flex flex-col h-full" data-id="element-265">
                {/* Десктопний заголовок та бейдж (сховано на мобільному) */}
                <div className="hidden lg:flex flex-col gap-4 mb-6" data-id="element-266">
                  <div className="inline-flex items-center gap-1.5 text-gray-500" data-id="element-267">
                    <ShieldCheck className="w-4 h-4" data-id="element-268" />
                    <span className="font-medium text-xs uppercase tracking-wider" data-id="element-269">
                      В наявності
                    </span>
                  </div>
                  <h1 className="text-4xl lg:text-5xl font-black text-brand-blue leading-tight" data-id="element-270">
                    {product.title}
                  </h1>
                </div>

                <p className="text-lg text-brand-muted font-medium mb-8 leading-relaxed" data-id="element-271">
                  {product.fullDesc}
                </p>

                <div className="space-y-4 mb-8 text-left" data-id="element-272">
                  <h3 className="font-bold text-brand-blue text-lg mb-2 text-center lg:text-left" data-id="element-273">
                    Що ви отримуєте:
                  </h3>
                  <div className="flex items-start gap-3" data-id="element-274">
                    <CheckCircle2 className="w-5 h-5 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-275" />
                    <div data-id="element-276">
                      <span className="font-bold text-brand-blue block text-sm" data-id="element-277">
                        Повністю магнітна основа
                      </span>
                      <span className="text-brand-muted text-sm" data-id="element-278">
                        Надійно тримається на холодильнику, не сповзає.
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-279">
                    <CheckCircle2 className="w-5 h-5 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-280" />
                    <div data-id="element-281">
                      <span className="font-bold text-brand-blue block text-sm" data-id="element-282">
                        Маркер з губкою в комплекті
                      </span>
                      <span className="text-brand-muted text-sm" data-id="element-283">
                        Легко пише та стирається без слідів.
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-284">
                    <CheckCircle2 className="w-5 h-5 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-285" />
                    <div data-id="element-286">
                      <span className="font-bold text-brand-blue block text-sm" data-id="element-287">
                        Багаторазове використання
                      </span>
                      <span className="text-brand-muted text-sm" data-id="element-288">
                        Пишіть, стирайте та плануйте знову і знову.
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-auto pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-289">
                  <div className="text-center sm:text-left w-full sm:w-auto" data-id="element-290">
                    <p className="text-sm text-brand-muted font-bold uppercase tracking-wider mb-1" data-id="element-291">
                      Вартість
                    </p>
                    <div className="text-4xl font-black text-brand-blue" data-id="element-292">
                      {product.price}{' '}
                      <span className="text-xl text-brand-muted" data-id="element-293">грн</span>
                    </div>
                  </div>
                  <button onClick={() => addItem(product)} className="w-full sm:w-auto px-8 py-4 bg-brand-yellow hover:bg-brand-yellowHover text-brand-blueDark rounded-xl font-black text-lg shadow-button transition-all transform hover:scale-105 flex items-center justify-center gap-2" data-id="element-294">
                    Замовити зараз
                    <ArrowRight className="w-5 h-5" strokeWidth={3} data-id="element-295" />
                  </button>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-brand-blue text-white py-10 mt-20" data-id="element-296">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-297">
          <div className="text-2xl font-black tracking-tight flex items-center" data-id="element-298">
            <span className="text-brand-yellow font-script italic mr-1" data-id="element-299">
              My
            </span>
            <span className="text-white" data-id="element-300">Planer</span>
          </div>
          <div className="text-blue-300 text-sm font-medium" data-id="element-301">
            © {new Date().getFullYear()} MyPlaner. Всі права захищені.
          </div>
        </div>
      </footer>
    </div>;
}